import { URL_STATUSES } from '../constants';

const USED_SOCIAL_MEDIA_TYPE = {
  YOUTUBE: 'YOUTUBE',
  INSTAGRAM: 'INSTAGRAM',
  FACEBOOK: 'FACEBOOK',
  TWITTER: 'TWITTER',
  TIKTOK: 'TIKTOK',
};

const compareSocials = (oldSocials, newSocials) => {
  return newSocials.map((social) => {
    if (social.status === URL_STATUSES.SUCCESS) {
      return social;
    }

    const oldSocial = oldSocials.find(({ url }) => url === social.url);

    return { url: social.url, status: oldSocial ? oldSocial.status : social.status };
  });
};

const updateNewSocialsStatuses = (oldDataset, newDataset) => {
  try {
    const newSocials = Object.keys(USED_SOCIAL_MEDIA_TYPE).reduce((acc, type) => {
      if (!newDataset.socials[type]) {
        return acc;
      }

      acc[type] = compareSocials(oldDataset.socials[type], newDataset.socials[type]);

      return acc;
    }, {});

    return { ...newDataset, socials: newSocials };
  } catch (error) {
    console.error(error);
    return newDataset;
  }
};

export default updateNewSocialsStatuses;
